module.exports = __webpack_public_path__ + "img/stena32.164c09f8.jpg";